import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function CardsPromptNode({ id, data }) {
    return (
        <NodeComponent title="Cards" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

